// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import { useState } from 'react';
import { Slider, Direction } from 'react-player-controls';

// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import { TimeBar } from './time-bar';
import { TimeIndicator } from './time-indicator';

// -------------------------------------------------------------------------------
// Utils, Styles and Assets
// -------------------------------------------------------------------------------
import { variables } from '../../../theme/theme-provider/variables';
import StyledTrackProgressBar from './styles';

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const TrackProgressBar = ({ value, max, onChange, transitionDuration }) => {
  const [state, setState] = useState({
    value: 0,
    lastIntent: 0,
  });

  return (
    <StyledTrackProgressBar>
      <div className="fr-track-progress-bar">
        <Slider
          className="fr-track-progress-bar__slider"
          direction={Direction.HORIZONTAL}
          onChange={onChange}
          onIntent={(intent) => setState({ ...state, lastIntent: intent })}
          onIntentEnd={() => setState({ ...state, lastIntent: 0 })}
        >
          <TimeBar width={100} type="background" backgroundColor={variables.colors.mercury} />
          <TimeBar
            width={(state.lastIntent || 0) * 100}
            backgroundColor="rgba(0, 0, 0, 0.05)"
            transition="all 0.2s linear"
          />
          <TimeBar
            width={(value / max) * 100}
            backgroundColor={variables.colors.casablanca}
            transition={`all ${transitionDuration}s linear`}
          />
          <TimeIndicator
            left={(value / max) * 100}
            backgroundColor={variables.colors.casablanca}
            transition={`all ${transitionDuration}s linear`}
          />
        </Slider>
      </div>
    </StyledTrackProgressBar>
  );
};

export default TrackProgressBar;
